import React from 'react';
import { Link } from 'react-router-dom';
import { SideNavigationItem } from '@adsk/alloy-side-navigation';
import safeGetPathname from '../../utils/safeGetPathname';

const LocalSideNavigationItem = (props) => {
  return (
    <SideNavigationItem
      {...props}
      as={Link}
      to={safeGetPathname(props.item.url)}
    />
  );
};

LocalSideNavigationItem.propTypes = {
  ...SideNavigationItem.propTypes,
};

export default LocalSideNavigationItem;
